import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from './errors'
import { telemetry } from '@/app/telemetry'

function report(error: unknown) {
  // ApiErrors are already reported (method, path template, status, request id) by the client.
  if (!(error instanceof ApiError)) telemetry.captureError(error)
}

export function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({ onError: report }),
    mutationCache: new MutationCache({ onError: report }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // 4xx will not fix itself by retrying; transient failures get one more try.
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 1,
      },
    },
  })
}

export const queryClient = createQueryClient()
